import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { IonicPage } from 'ionic-angular';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { isEmpty, has } from 'lodash';
import { MessageData } from '../../providers/messages';
import { UtilitiesProvider } from '../../providers/utilities';
import { IUser } from '../../models/user.model';
import { IClientConfig } from '../../models/client.model';
import { IAlertMessage, IToastMessage } from '../../models/message.model';
import { TranslateCodePipe } from '../../pipes/translate';
import * as clientSelectors from '../../ngrx/reducers/client.reducer';
import * as userSelectors from '../../ngrx/reducers/auth.reducer';

@IonicPage()
@Component({
  selector: 'page-messages',
  templateUrl: 'messages.html',
})
export class MessagesPage implements OnInit, OnDestroy {

  private clientIdSubs: Subscription;
  private clientId: string;
  private clientInformationSubs: Subscription;
  private clientInformation: IClientConfig;
  private currentAlertMessageSubs: Subscription;
  private currentAlertMessage: IAlertMessage;
  private currentToastMessageSubs: Subscription;
  private currentToastMessage: IToastMessage;
  private userSubs: Subscription;
  private userInformation: IUser;
  private alert: any = null;
  private userClientHasViewMessageSubs: Subscription;
  private saveClientStatisticAndViewSubs: Subscription;

  @Input('itsEvent') public itsEvent: boolean;

  constructor(
    public store: Store<{}>,
    private messageData: MessageData,
    private utilities: UtilitiesProvider,
    private translatePipe: TranslateCodePipe
  ) {
  }

  ngOnInit() {
    this.getClientId();
    this.getUser();
  }
  private getClientId() {
    this.clientIdSubs = this.store.select(clientSelectors.getClientId).subscribe((clientId) => {
      if (clientId) {
        this.clientId = clientId;
        this.getClientInformation();
        this.getCurrentAlertMessage();
        this.getCurrentToastMessage();
      }
    });
  }

  private getClientInformation() {
    this.clientInformationSubs = this.store.select(clientSelectors.getClientConfig).subscribe((clientConfiguration) => {
      if (clientInformation) {
        this.clientInformation = clientConfiguration;
      }
    });
  }

  private getUser() {
    this.userSubs = this.store.select(userSelectors.getUser).subscribe((user) => {
      this.userInformation = user;
    })
  }

  private getCurrentAlertMessage() {
    this.currentAlertMessageSubs = this.messageData.getClientAlertMessageActive().subscribe((messageActive: IAlertMessage[]) => {
      if (!isEmpty(messageActive)) {
        this.currentAlertMessage = messageActive[0];
        this.userHasViewAlertMessage();
      } else {
        this.currentAlertMessage = null;
      }
    })
  }

  private getCurrentToastMessage() {
    this.currentToastMessageSubs = this.messageData.getClientToastMessageActive().subscribe((messageActive: IToastMessage[]) => {
      this.utilities.consoleDecorator('messageActive general', messageActive);
      if (!isEmpty(messageActive)) {
        this.currentToastMessage = messageActive[0];
        this.userHasViewToastMessage();
      } else {
        this.currentToastMessage = null;
      }
    })
  }

  private userHasViewAlertMessage() {
    this.messageData.userClientHasViewMessage('Alert', this.currentAlertMessage.id, this.userInformation.info.id).subscribe((hasViews) => {
      if (!hasViews) {
        this.displayAlertMessage();
      }
    })
  }

  private async displayAlertMessage() {
    if (!this.itsEvent) {

      this.utilities.consoleDecorator('alert new general', this.currentAlertMessage);

      if (!this.alert) {
        this.alert = this.utilities.alert.create({
          title: await this.translatePipe.transform(this.currentAlertMessage['title']),
          message: this.currentAlertMessage['text'][this.clientInformation.defaultLanguage],
          buttons: ['Ok']
        });

        this.messageData.saveClientStatisticAndView('Alert', this.currentAlertMessage.id, this.userInformation.info.id).subscribe(() => {
          this.utilities.consoleDecorator('Alert general message and statistic saved', '', 'orange');
        });

        this.alert.present();

        this.alert.onDidDismiss(() => {
          this.utilities.consoleDecorator('alert general dismiss', this.alert);
          this.alert = null;
        })
      } else {
        this.utilities.consoleDecorator('alert general taken', this.alert);
        this.alert = null;
      }
    }
  }

  private userHasViewToastMessage() {
    this.userClientHasViewMessageSubs = this.messageData.userClientHasViewMessage('Toast', this.currentToastMessage.id, this.userInformation.info.id).subscribe((hasViews) => {
      this.utilities.consoleDecorator('message general hasViews', hasViews);
      if (!hasViews) {
        this.displayToastMessage();
      }
    })
  }

  private displayToastMessage() {
    let alertToastRecieved = this.utilities.toast.create({
      message: this.currentToastMessage['title'],
      duration: this.currentToastMessage.callback ? 0 : this.currentToastMessage.timeout,
      position: this.currentToastMessage.position,
      showCloseButton: true,

    });

    let target = "_self";
    if (has(this.currentToastMessage, "is_external")) {
      if (this.currentToastMessage.is_external) {
        target = "_blank"
      }
    }

    alertToastRecieved.present();
    alertToastRecieved.onDidDismiss((data, role) => {
      if (role === 'close') {
        if (this.currentToastMessage.callback !== '') {
          window.open(this.currentToastMessage.callback, target);
        }
      }
      this.saveClientStatisticAndViewSubs = this.messageData.saveClientStatisticAndView('Toast', this.currentToastMessage.id, this.userInformation.info.id)
        .subscribe(() => {
          this.utilities.consoleDecorator('Toast general message and statistic saved', '', 'orange');
        })
    })
  }

  ngOnDestroy() {
    if (this.clientIdSubs) this.clientIdSubs.unsubscribe();
    if (this.clientInformationSubs) this.clientInformationSubs.unsubscribe();
    if (this.userSubs) this.userSubs.unsubscribe();
    if (this.currentAlertMessageSubs) this.currentAlertMessageSubs.unsubscribe();
    if (this.currentToastMessageSubs) this.currentToastMessageSubs.unsubscribe();
    if (this.userClientHasViewMessageSubs) this.userClientHasViewMessageSubs.unsubscribe();
    if (this.saveClientStatisticAndViewSubs) this.saveClientStatisticAndViewSubs.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/pages/messages/messages.ts